import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { ConfigurationModel, WashBasinModel } from 'franke-trough-dependencies';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Tooltip, Button } from 'reactstrap';
import { requestAPIActions } from 'loopback-react-request';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './BasinDimensions.messages';

export interface DepthRequiredProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
  id: string;
  requiredDepth?: number;
}

export interface DepthRequiredState {
  tooltipOpen: boolean;
}

export class DepthRequiredPartial extends React.Component<DepthRequiredProps, DepthRequiredState> {
  constructor(props: DepthRequiredProps) {
    super(props);

    this.state = {
      tooltipOpen: false
    };
    this.toggle = this.toggle.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  public render() {
    const tollTipId = `depth_required_tooltip_${this.props.id}`;
    return this.isDepthRequired ? (
      <>
        <span className="info-icon" id={tollTipId}>
          <FontAwesomeIcon icon={faInfo} />
          <Tooltip 
            autohide={false}
            isOpen={this.state.tooltipOpen} 
            placement="top"
            toggle={this.toggle}
            target={tollTipId}
          >
            <p>
              <strong>
                <FormattedMessage {...MESSAGES.depthRequiredHint}/>
              </strong>&nbsp;<FormattedMessage {...MESSAGES.depthRequiredMessage} values={{requiredDepth: this.requiredDepth}}/>
            </p>
            <p className="text-right">
              <Button 
                onClick={(ev: React.MouseEvent<HTMLButtonElement>) => this.handleClick(ev, 'submit')}
                className="yes"
              >
                <FontAwesomeIcon icon={faCheck} />
              </Button>
            </p>
          </Tooltip>
        </span>
      </>
    ) : null;
  }


  private get isDepthRequired(): boolean {
    if (this.requiredDepth === 0) {
      return false;
    }
    if (!this.configuration || !this.configuration.washBasinDimension || this.requiredDepth > this.configuration.washBasinDimension.plateDepth) {
      return true;
    }
    return false;
  }

  private get configuration(): ConfigurationModel | undefined {
    return this.props.configuration && this.props.configuration.result;
  }

  private get requiredDepth(): number {
    return this.props.requiredDepth || 0;
  }

  private dispatchConfiguration() {
    if (!this.configuration) { return; }
    const { washBasinDimension } = this.configuration;

    // TODO ... Use default values for apronHeight
    if (!washBasinDimension) { return; }
    const data: WashBasinModel = washBasinDimension;
    data.plateDepth = this.requiredDepth;

    this.props.dispatch(requestAPIActions.load(
      'configuration', {
        url: `/Configurations/${this.configuration && this.configuration.id}`,
        options: {
          method: 'PATCH',
          data: {washBasinDimension: data}
        },
      },
      true,
    ));
  }

  private handleClick(event: React.MouseEvent<HTMLButtonElement>, type: 'submit' | 'cancel') {
    if (type === 'submit') {
      this.dispatchConfiguration();
    }
  }

  private toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }
}

export const DepthRequired = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
}))(DepthRequiredPartial);

export default DepthRequired;


